* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f6f6f8;
  color: #111;
}
